import { TotalCostOptimizationsActionTypes } from './constants';

type TotalCostOptimizationsAction = { type: string, payload: {} | string };

export const totalCostOptimizationsApiResponseSuccess = (actionType: string, data: any): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const totalCostOptimizationsApiResponseError = (actionType: string, error: string): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTotalChargeAmount = (query): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT,
    payload: { query },
});

export const getTotalAuditableAmount = (query): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT,
    payload: { query },
});

export const getAvgTotalChargeAmount = (query): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT,
    payload: { query },
});

export const getComparisonTotalChargeAmount = (query): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT,
    payload: { query },
});

export const getComparisonAvgTotalChargeAmount = (query): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT,
    payload: { query },
});

export const getTotalCostByWeightAndZone = (query): TotalCostOptimizationsAction => ({
    type: TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE,
    payload: { query },
});